module.exports = __webpack_public_path__ + "img/exhibition_tape_12mm.24667fd9.jpg";